module.exports = __webpack_public_path__ + "img/footer_logo_hk.0128554c.png";